import {
  Swiper, Pagination, Autoplay, Lazy,
} from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  let autoplayStarted = false;
  const sliderPopup = document.getElementById('sliderPopup');

  const swiperSlides = sliderPopup.getElementsByClassName('swiper-slide');
  const noOfSwiperSlide = swiperSlides.length;
  function centerActiveCategory() {
    const categoryHolder = document.querySelector('.category-holder');
    const activeCategory = document.querySelector('.list-category.active-category');

    if (window.innerWidth < 580 && categoryHolder && activeCategory) {
      const scrollLeft = activeCategory.offsetLeft
          - (categoryHolder.offsetWidth - activeCategory.offsetWidth) / 2;

      categoryHolder.scroll({
        left: scrollLeft,
        behavior: 'smooth',
      });
    }
  }

  function updateActiveCategory(category) {
    const categoryLinks = document.querySelectorAll('.category-holder .list-category');
    [...categoryLinks].forEach((categoryLink) => {
      categoryLink.classList.remove('active-category');
    });
    const activeCategory = category || 'marketing';
    const activeCategoryLink = document.querySelector(`.category-holder .list-category[data-target="${activeCategory}"]`);
    if (activeCategoryLink) {
      activeCategoryLink.classList.add('active-category');
    }
    // Hide all bullets by default
    const bullets = document.querySelectorAll('.swiper-pagination-bullet');
    [...bullets].forEach((bullet, index) => {
      bullets[index].style.display = 'none';
    });
    // Show bullets for the active category
    const activeCategoryBullets = document.querySelectorAll(`.swiper-pagination-bullet[data-category="${activeCategory}"]`);
    [...activeCategoryBullets].forEach((activeBullet, index) => {
      activeCategoryBullets[index].style.display = 'inline-block';
    });

    centerActiveCategory();
  }

  Swiper.use([Autoplay, Lazy, Pagination]);
  const mainSwiper = new Swiper('#sliderPopup', {
    loop: true,
    centeredSlides: true,
    spaceBetween: 24,
    autoplay: {
      delay: 2000,
      pauseOnMouseEnter: false,
      enabled: false,
    },
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 3,
      loadOnTransitionStart: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet(index, className) {
        const slide = document.querySelector(`.swiper-slide:not(.swiper-slide-duplicate)[data-swiper-slide-index="${index}"]`);
        const category = slide.getAttribute('data-category');
        const isActive = slide.classList.contains('swiper-slide-active');
        const bulletClass = isActive ? 'swiper-pagination-bullet-active' : 'swiper-pagination-bullet-visible';
        return `<span class="${className} ${bulletClass}" data-category="${category}"></span>`;
      },
    },
    loopedSlides: noOfSwiperSlide,
    on: {
      slideChangeTransitionEnd: () => {
        const activeCategoryElement = document.querySelector('.swiper-slide.swiper-slide-active[data-category]');
        const activeCategory = activeCategoryElement ? activeCategoryElement.getAttribute('data-category') : null;
        updateActiveCategory(activeCategory);
      },
    },
    breakpoints: {
      260: {
        slidesPerView: 1.2,
      },
      370: {
        slidesPerView: 1.51,
      },
      769: {
        slidesPerView: 2.3,
      },
      1440: {
        slidesPerView: 3.2,
      },
    },
  });

  // carousel autoplay starts only on viewport
  function handleAutoplayOnScroll() {
    if (!autoplayStarted) {
      const sliderPopupRect = sliderPopup.getBoundingClientRect();
      if (sliderPopupRect.top < window.innerHeight && sliderPopupRect.bottom >= 0) {
        mainSwiper.autoplay.start();
        autoplayStarted = true;
        // Remove the scroll event listener once autoplay starts
        window.removeEventListener('scroll', handleAutoplayOnScroll);
      }
    }
  }
  window.addEventListener('scroll', handleAutoplayOnScroll);

  function pauseAutoplay() {
    if (mainSwiper && mainSwiper.autoplay && mainSwiper.autoplay.running) {
      mainSwiper.autoplay.stop();
    }
  }

  function resumeAutoplay() {
    if (mainSwiper && mainSwiper.autoplay && !mainSwiper.autoplay.running) {
      mainSwiper.autoplay.start();
    }
  }

  if (mainSwiper) {
    mainSwiper.el.addEventListener('mouseenter', pauseAutoplay);
    mainSwiper.el.addEventListener('mouseleave', resumeAutoplay);
    updateActiveCategory();
  }

  const categoryLinks = document.querySelectorAll('.category-holder .list-category');
  [...categoryLinks].forEach((categoryLink) => {
    categoryLink.addEventListener('click', () => {
      const targetCategory = categoryLink.getAttribute('data-target');
      const targetSlide = document.querySelector(`.swiper-slide[data-category="${targetCategory}"]`);
      if (targetSlide) {
        const targetIndex = Array.from(targetSlide.parentNode.children).indexOf(targetSlide);
        mainSwiper.slideToLoop(targetIndex);
        updateActiveCategory(targetCategory);
      }
    });
  });
});
